import type { CadstromObjectType } from '@cadstrom/cadstrom-shared';
import type { ComponentType } from 'react';
import type { CommandBarProviderProps } from '#components/command-bar/command-bar-types.js';

export const CADSTROM_UID_PROVIDER_ID = 'cadstrom-uid';

export interface CadstromUidProviderProps extends CommandBarProviderProps {
	supportedTypes: CadstromObjectType[];
}

export interface CadstromUidResultProps {
	/** The Cadstrom UID entered into the command bar (already trimmed). */
	uid: string;
	onClose: () => void;
}

/**
 * A component that knows how to query a single object by its Cadstrom UID and
 * render a navigable command-bar result for it.
 */
export type CadstromUidResultComponent = ComponentType<CadstromUidResultProps>;
